<template>
  <div class="like">
    <h1>{{ $t("message.like_title") }}</h1>
    <div class="icon_description">
        <span><i class="fas fa-volume-up"></i>...{{ $t("message.like_voice") }} </span>
        <span><i class="fas fa-pen"></i>...{{ $t("message.like_edit") }} </span>
        <span><i class="far fa-copy"></i>...{{ $t("message.like_copy") }} </span>
        <span><i class="far fa-trash-alt"></i>...{{ $t("message.like_delete") }}</span>
    </div>
    <div class="card" v-for="c in contentSort" :key="c.id">
      <div v-if="!c.del">
        <div class="card-content">
          <div :id="c.id + '_both'">
            <div class="translate_word">
              <p v-if="c.content == c.translated.en">{{c.translated.ja}}</p>
              <p v-if="c.content == c.translated.ja">{{c.translated.en}}</p>
              <p v-if="c.content != c.translated.ja && c.content != c.translated.en">{{c.translated.en}}<br>{{c.translated.ja}}</p>
            </div>
            <p class="traslated_word_content" :id="c.id" v-if="!c.isEdit">{{c.content}}</p>
            <p v-if="c.isEdit"><b-input type="textarea" v-model="c.translated.en" rows="3" maxlength="1000"></b-input></p>
            <p v-if="c.isEdit">
              <b-button class="is-info" size="is-small" @click="editText(c)" outlined>{{ $t("message.like_change_text") }}</b-button> 
              <span class="back_text"><b-button size="is-small" type="is-primary" @click="c.isEdit = !c.isEdit" outlined>{{ $t("message.like_change_back") }}</b-button></span>
            </p>
          </div>
          <p class="date">{{c.time}}({{c.week}})</p>
        </div>
        <div class="columns is-9 is-marginless">
          <div class="column">
            <span><b-button type="is-text" @click="speech(c.translated.en)"><i class="fas fa-volume-up"></i></b-button></span>
            <span><b-button type="is-text" @click="c.isEdit = !c.isEdit"><i class="fas fa-pen"></i></b-button></span>

            <b-dropdown aria-role="list">
              <button class="button is-text" slot="trigger">
                  <span><i class="far fa-copy"></i></span>
              </button>

              <b-dropdown-item aria-role="listitem" @click="clipboard(c.id)">{{ $t("message.like_copy_en") }}</b-dropdown-item>
              <b-dropdown-item aria-role="listitem" @click="clipboardBoth(c.id)">{{ $t("message.like_copy_both") }}</b-dropdown-item>
            </b-dropdown>
          
            <span><b-button type="is-text" @click="trash(c)"><i class="far fa-trash-alt"></i></b-button></span>
          </div>
          <div class="column is-3 share_column">
            <b-button class="is-info" icon-left="twitter" @click="twitterShare(c.translated)">{{ $t("message.like_share") }}</b-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import firebase from 'firebase/app'
import moment from 'moment'
import store from '@/store'
export default {
  name: 'like',
  data(){
    return{
      content: []
    }
  },
  mounted(){
    const title = "お気に入り｜メモや日記ついでに英語学習"
    const description = "メモや日記ついでに英語学習のお気に入り画面です。"
    document.title = title
    document.querySelector("meta[property='og:title']").setAttribute('content', title)
    document.querySelector("meta[name='description']").setAttribute('content', description)
    document.querySelector("meta[property='og:description']").setAttribute('content', description)
  },
  computed: {
    user(){
      return this.$store.getters.user;
    },
    // 時間で並び替え
    contentSort(){
        var vm = this
        return vm.content.sort((a, b) => {
          return (a.createdAt < b.createdAt) ? 1 : (a.createdAt > b.createdAt) ? -1 : 0;
        });
    }
  },
  created() {
    store.commit('start')
    firebase.firestore().collection("user").doc(this.user.uid).collection("like").get().then((querySnapshot) => {
      querySnapshot.forEach((doc) => {
        var data = doc.data()
        data.id = doc.id
        data.isEdit = false
        data.del = false
        data.week = moment.unix(data.createdAt.seconds).locale('ja').format('dddd')
        data.time = moment.unix(data.createdAt.seconds).locale('ja').format('ll')
        this.content.push(data)
        })
      }).then(()=>{
        store.commit('end')
      }).catch(()=>{
        store.commit('end')
      });
  },
  methods: {
    speech(speech_text){
      // 発言を作成
      const uttr = new SpeechSynthesisUtterance(speech_text)
      uttr.lang = "en-US"
      // 発言を再生 (発言キューに発言を追加)
      speechSynthesis.speak(uttr)
    },
    // like(content){

    // },
    trash(content_data){
      var vm = this
      var targetId = content_data.id;
      for (var key in this.content) {
        if(this.content[key].id == targetId){
          var push_key = key
        }
      }
      this.$buefy.dialog.confirm({
        message: '削除しますか？',
          onConfirm: () =>  
            firebase.firestore().collection('user').doc(content_data.uid).collection('like').doc(content_data.id).delete().then(() => {
                vm.$buefy.toast.open('削除しました！')
                vm.content[push_key].del = true;
            }).catch(function() {
                vm.$buefy.toast.open('おや？削除に失敗しました');
          })
      })
    },
    editText(content){
      console.log(content)
      var vm = this
      this.$buefy.dialog.confirm({
        message: '変更しますか？',
          onConfirm: () =>  
          firebase.firestore().collection('user').doc(content.uid).collection('like').doc(content.id).set({
            translated: content.translated 
          },{ merge: true }).then(()=>{
            vm.$buefy.toast.open('変更しました！')
          }).catch(function() {
            vm.$buefy.toast.open('おや？変更に失敗しました');
          })
      })
    },
    twitterShare(translated){
      var twitter_share_url = 'https://twitter.com/intent/tweet?text=' + translated.en + "%0a%0a" + translated.ja + "%0a%0a" + "%20%23メモ英" + "%20%23メモや日記ついでに英語学習" + "%20" + "https://translate.ameneko.com/"  
      window.open(twitter_share_url, '_blank')  
    },
    clipboard(id){
      let range = document.createRange();
      let english_text = document.getElementById(id);
      range.selectNodeContents(english_text);

      //指定した範囲を選択状態にする
      let selection = document.getSelection();
      selection.removeAllRanges();
      selection.addRange(range);

      //コピー
      document.execCommand('copy');
      this.$buefy.toast.open('コピーしました！')
    },
    clipboardBoth(id){
      let both = id + "_both"
      let range = document.createRange();
      let english_text = document.getElementById(both);
      range.selectNodeContents(english_text);

      //指定した範囲を選択状態にする
      let selection = document.getSelection();
      selection.removeAllRanges();
      selection.addRange(range);

      //コピー
      document.execCommand('copy');
      this.$buefy.toast.open('コピーしました！')
    }
  }
}
</script>
<style scoped>
h1{
  font-weight: bold;
  font-size: 1.2em;
  text-align: center;
  padding-bottom: 10px;
}
hr{
  margin-top: 12px;
}
.like{
  max-width: 800px;
  margin:auto;
}
.card-content{
  padding-right:10px;
  padding-left:10px;
  padding-bottom: 10px;
}
.icon_description{
  text-align: center;
  font-size: .8em;
  padding:10px;
}
.date{
  font-size: .8em;
  text-align: right;
}
p{
  padding-left:10px;
  padding-right: 10px;
}
span{
  padding-left:4px;
}
.share_column{
  padding-right: 20px;
  text-align: right;
}
.traslated_word_content{
  padding-top: 10px;
  font-size: .9em;
}
.translate_word{
  font-size: 1.1em;
  font-weight: bold;
}
</style>